import { makeStyles } from "@material-ui/core";
import { Grid, Paper } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { ParamTypes } from "../../../../core/helpers/url";
import { useAppDispatch } from "../../../store";
import { getFichierSollicitation } from "../../../store/expertise/expertise.action";

const useStyles = makeStyles((theme) => ({
	paper: {
		padding: theme.spacing(2),
		margin: "auto",
		marginTop: theme.spacing(7),
		maxWidth: 700,
		maxHeight: 500,
	},
}));

export default function DownloadDocumentPrerequis() {
	const dispatch = useAppDispatch();
	const { idDocument } = useParams<ParamTypes>();
	const [downloadOK, setDownloadOk] = useState(false);
	const classes = useStyles();

	useEffect(() => {
		if (idDocument) {
			dispatch(getFichierSollicitation(idDocument))
				.then(() => {
					setDownloadOk(true);
				});
		}
	}, [dispatch, idDocument]);

	return (
		<>
			{downloadOK && (
				<Paper className={classes.paper}>
					<Grid container alignContent="center">
						<Grid item>Le document demandé a bien été téléchargé. Vous pouvez maintenant fermer cet onglet.</Grid>
					</Grid>
				</Paper>
			)}
		</>
	);
}
